import React, { useState } from 'react';

import Box from '@mui/material/Box';

import SliderIcon from 'ff/debrief/components/customIcons/SliderIcon';

interface Props {
    onClick?: () => void;
    showScoreDetails?: boolean;
}

const PanelDivider = ({
    onClick,
    showScoreDetails,
}: React.PropsWithChildren<Props>) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <Box
            sx={{
                width: 20,
                height: 1,
                bgcolor: 'transparent',
                '&:hover > div': { bgcolor: '#3498DB' },
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={onClick}
        >
            <Line>
                <Slider isVisible={isHovered} flip={showScoreDetails} />
            </Line>
        </Box>
    );
};

const Line = ({ children }: React.PropsWithChildren) => (
    <Box
        sx={{
            height: 1,
            mx: 'auto',
            width: '1px',
            bgcolor: '#D8DADB',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'visible',
        }}
    >
        {children}
    </Box>
);

interface SliderProps {
    isVisible: boolean;
    flip: boolean;
}

const Slider = ({ isVisible, flip }: SliderProps) => (
    <Box sx={{ transition: 'opacity 0.3s ease' }}>
        <SliderIcon
            sx={{
                width: 24,
                height: 24,
                borderRadius: 12,
                transition: 'transform 0.3s ease',
                transform: flip ? 'rotate(-180deg)' : null,
                '& circle': {
                    fill: isVisible ? '#3498DB' : 'white',
                    transition: 'fill 0.3s ease',
                    stroke: isVisible ? '#3498DB' : '#D8DADB',
                },
                '& path': {
                    fill: isVisible ? 'white' : '#b4b4b6',
                    transition: 'fill 0.3s ease',
                },
            }}
        />
    </Box>
);

export default PanelDivider;
